export type CSRPCustomerType = {
  id: number;
  description: string;
  active: boolean;
};

export type CSRPCustomerBillingGroupType = {
  id: number;
  description: string;
  active: boolean;
  customer: CSRPCustomerType;
};

export type CSRPRouteType = {
  id: number;
  description: string;
  active: boolean;
  prefix: string;
  overflowRouting: boolean;
  overflowDnis: string;
  customerBillingGroup: CSRPCustomerBillingGroupType;
  origRate: CSRPRateType;
};

export type CSRPRateType = {
  id: number;
  description: string;
  active: boolean;
  minDuration: number;
  durationIncr: number;
  minuteCost: number;
  padSec: number;
  packageRate: boolean;
  attestAni: boolean;
};

export enum OrigRouteCosDestClassDestType {
  BG = 'bg',
  VM = 'vm',
  PSTN = 'pstn',
  CLASS5ARENA = 'class5arena',
  BG_RR = 'bg_rr',
}

export type CSRPVendorType = {
  id: number;
  description: string;
  active: boolean;
};

export type CSRPConditionaTranslationType = {
  id: number;
  description: string;
};

export type CSRPConditionaTranslationPrefixRuleType = {
  id: number;
  inPrefix: string;
  inTarget: string;
  inTargetLength: number;
  outTarget: string;
  stripDigits: number;
  prependPrefix: string;
  appendSuffix: string;
  conditionalTranslation: CSRPConditionaTranslationType;
};

export type CSRPCosDestinationType = {
  id: number;
  classDest: string;
  classDestType: string;
};

export type CSRPInformation = {
  origRouteId: number;
  vendorRouteId: number;
  customerBillingGroup: CSRPCustomerBillingGroupType;
  vendor: CSRPVendorType;
  dnis?: CSRPConditionaTranslationPrefixRuleType;
  cosDestination?: CSRPCosDestinationType;
};
